import ko from "knockout";
import * as mapping from 'knockout-mapping';
import val from '../../val';
import axios from "axios";

function mapDictionaryToArray(dictionary) {
    var result = [];
    for (var key in dictionary) {
        if (dictionary.hasOwnProperty(key)) {
            result.push({ key: key, value: dictionary[key] });
        }
    }

    return result;
}

var PriceYourRoom = {

   

    init: async function(data) {
        data.chooseRoomMode = function(roomMode) {
            data.RoomSettings.RoomMode(roomMode);
        }

        var defaultToShow = (data.RoomSettings.Rooms().length == 0);
        
        var palletOptionAvailable = document.getElementById('pallets-tab') != null;
        if (data.RoomSettings.RoomMode() == '2' && !palletOptionAvailable)
        {
            data.RoomSettings.RoomMode(0);  // switch back to area mode if no pallet available
        }
        
        data.showConfirmDeleteRoom = ko.observable(false);
        data.showAddRoom = ko.observable(defaultToShow);
        data.addRoomExistingId = ko.observable('');
        data.addRoomName = ko.observable('');
        data.addRoomAreaIsWidthLength = ko.observable(false);
        data.addRoomAreaWidth = ko.observable(0);
        data.addRoomAreaLength = ko.observable(0);
        data.addRoomUserInputtedM2 = ko.observable(0);
        data.addRoomUsingFeet = ko.observable(false);
        
        data.packsOrPallets = ko.computed(function() {
            if (data.RoomSettings.RoomMode() == '2')
                return 'pallets';
            
            return 'packs';
        });
        
        data.addRoomButtonText = ko.computed(function() {
            return data.addRoomExistingId() == '' ? 'Add Room' : 'Update Room';
        });
        
        data.AnotherOrA = ko.computed(function() {
            if (data.Rooms().length == 0)
                return "a";
            
            return "Another";
        })
        
        data.roomAreaFtText = ko.computed(function() {
            if (data.RoomSettings.AreaIsWidthLength()) {
                return 'ft';
            }
            else {
                return 'ft2';
            }
        });

        data.roomAreaMText = ko.computed(function() {
            if (data.RoomSettings.AreaIsWidthLength()) {
                return 'm';
            }
            else {
                return 'm2';
            }
        });
        
        data.roomAreaM2orFt2 = ko.computed(function() {
            if (data.RoomSettings.UsingFeet()) {
                return 'ft2';
            }
            else {
                return 'm2';
            }
        })
        
        data.roomMOrFt = ko.computed(function() {
            if (data.RoomSettings.UsingFeet()) {
                if (data.RoomSettings.AreaIsWidthLength()) {
                    return 'ft';
                }
                else {
                    return 'ft2';
                }
            }
            else {
                if (data.RoomSettings.AreaIsWidthLength()) {
                    return 'm';
                }
                else {
                    return 'm2';
                }
            }
        })

        data.addRoomAreaFtText = ko.computed(function() {
            if (data.addRoomAreaIsWidthLength()) {
                return 'ft';
            }
            else {
                return 'ft2';
            }
        });

        data.addRoomAreaMText = ko.computed(function() {
            if (data.addRoomAreaIsWidthLength()) {
                return 'm';
            }
            else {
                return 'm2';
            }
        });
        
        data.addRoomMOrFt = ko.computed(function() {
            if (data.addRoomUsingFeet()) {
                if (data.addRoomAreaIsWidthLength()) {
                    return 'ft';
                }
                else {
                    return 'ft2';
                }
            }
            else {
                if (data.addRoomAreaIsWidthLength()) {
                    return 'm';
                }
                else {
                    return 'm2';
                }
            }
        })
        
        data.totalRoomM2 = ko.computed(function() {
            let total = 0;
            ko.utils.arrayForEach(data.RoomSettings.Rooms(), function(item:any) {
                var value = parseFloat(item.AreaTotalM2());
                if (!isNaN(value)) {
                    total += value;
                }
            });
            return total;
        });
        
        data.saveRoom = async function() {
            var formData = {
                Id: data.addRoomExistingId(),
                Name: data.addRoomName(),
                AreaIsWidthLength: data.addRoomAreaIsWidthLength(),
                AreaWidth: data.addRoomAreaWidth(),
                AreaLength: data.addRoomAreaLength(),
                UserInputtedM2: data.addRoomUserInputtedM2(),
                UsingFeet: data.addRoomUsingFeet()
            }

            $(".saveroom").addClass('disabled');
          
            var json = JSON.stringify(formData);
            
            try {
                var result = await axios.put('/basket/saveroom', formData);

                if (data.addRoomExistingId() == '')
                {
                    var roomMapped = mapping.fromJS(result.data);
                    data.RoomSettings.Rooms.push(roomMapped);
                    data.RoomSettings.SelectedRoom(roomMapped.Id())
                }
                else {
                    var updatedRoom:any = ko.utils.arrayFirst(this.RoomSettings.Rooms(), function(item) {
                        return item.Id() == data.addRoomExistingId();
                    });

                    //updatedRoom.Name('new name')
                    mapping.fromJS(result.data, {}, updatedRoom)
                    data.RoomSettings.SelectedRoom(updatedRoom.Id())
                }

                $(".saveroom").removeClass('disabled');

                data.showAddRoom(false);
                
            }
            catch(err) {
                $(".saveroom").removeClass('disabled');
                val.displayErrors(err.response.data, '#room-validation-summary');
            }
        }
        
        data.initAddRoom = function() {
            data.addRoomExistingId('');
            data.addRoomName('');
            data.addRoomAreaLength(0);
            data.addRoomAreaWidth(0);
            data.addRoomUserInputtedM2(0);
            data.showAddRoom(true);
        };
        
        data.editRoom = function() {
            var selectedRoom:any = ko.utils.arrayFirst(this.RoomSettings.Rooms(), function(item) {
                return item.Id() == data.RoomSettings.SelectedRoom();
            });
            
            data.addRoomName(selectedRoom.Name());
            data.addRoomExistingId(selectedRoom.Id());
            data.addRoomAreaIsWidthLength(selectedRoom.AreaIsWidthLength());
            data.addRoomAreaLength(selectedRoom.AreaLength());
            data.addRoomAreaWidth(selectedRoom.AreaWidth());
            data.addRoomUserInputtedM2(selectedRoom.UserInputtedM2());
            data.addRoomUsingFeet(selectedRoom.UsingFeet());
            data.showAddRoom(true);
        }
        
        data.initDeleteRoom = function() {
            data.showConfirmDeleteRoom(true);
        }
        data.cancelDeleteRoom = function() {
            data.showConfirmDeleteRoom(false);
        }
        data.deleteRoom = async function() {
            // delete selected room and update
            var roomId = data.RoomSettings.SelectedRoom();
            
            try {
                var result = await axios.delete('/basket/remvoeroom/' + roomId);

                var selectedRoom: any = ko.utils.arrayFirst(this.RoomSettings.Rooms(), function (item) {
                    return item.Id() == data.RoomSettings.SelectedRoom();
                });

                data.RoomSettings.Rooms.remove(selectedRoom);

                if (data.RoomSettings.Rooms().length == 0) {
                    data.showAddRoom(true);
                    data.addRoomExistingId('');
                    data.RoomSettings.SelectedRoom('');
                } else {
                    data.RoomSettings.SelectedRoom(data.RoomSettings.Rooms()[0].Id());
                }

                data.showConfirmDeleteRoom(false);
            }
            catch(err) {
                
            }
        }

        // deferred will throttle the ajax requests
        ko.computed(function () {
            return ko.toJSON(data.RoomSettings);
        })
            .extend({ deferred: true })
            .subscribe(function ()
        {
            recalculatePrice();
        })
        
        data.ValidCarpetPostcode = ko.observable(false);
 
        var updatePrices = async result => {
            mapping.fromJS(result, {}, data.Pricing);
        }
        
        var recalculatePrice = async function () {
            var url = $("#addbasket").attr('data-price-url');
            
            var ajaxData = mapping.toJS(data.RoomSettings);

            try {
                var result = await axios.post(url, ajaxData);
                updatePrices(result.data);
            }
            catch(err) {
                
            }
        }

        data.postcodeChanged = function(place) {
            recalculatePrice();
        };
    }
    
}

export {PriceYourRoom as default};